import React from 'react'

export const LoadEffect = React.memo((props)=>{
    return <React.Fragment>  
        

        <div className="loading-overlay">
              <div className="loading-spinner">
                <div className="spinner-circle"></div>
                <div className="spinner-circle"></div>
                <div className="spinner-circle"></div>
                <div className="loading-text">Loading in...</div>
              </div>
            </div>

    </React.Fragment>
});

export const Loader = ()=>{
    return <React.Fragment>  
          <div className="loader-block overlay">
          <svg id="loader2" viewBox="0 0 100 100">
        <circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
    </svg> 
                        </div>
    </React.Fragment>
}

 export const TableLoader = React.memo(()=>{
    return <React.Fragment>  
          <div className="preloader3 loader-block">
            <div className="circ1 loader-primary"></div>
            <div className="circ2 loader-primary"></div>
            <div className="circ3 loader-primary"></div>
            <div className="circ4 loader-primary"></div>
        </div>
    </React.Fragment>
})

export default React.memo(Loader)